/**
 * Core Web Vitals reporting.
 * Uses the web-vitals library to measure CLS, FID, LCP, FCP, TTFB.
 * Reports to console in development, GA4 in production.
 */

const reportWebVitals = (onPerfEntry) => {
  if (onPerfEntry && typeof onPerfEntry === 'function') {
    import('web-vitals').then(({ onCLS, onFID, onLCP, onFCP, onTTFB }) => {
      onCLS(onPerfEntry);
      onFID(onPerfEntry);
      onLCP(onPerfEntry);
      onFCP(onPerfEntry);
      onTTFB(onPerfEntry);
    });
  }
};

export { reportWebVitals };
